module.exports = __webpack_public_path__ + "img/0ad4a33.jpg";